import { render } from "./TextWithFallbackDisplay.vue?vue&type=template&id=4ea2f464"
import script from "./TextWithFallbackDisplay.vue?vue&type=script&lang=js"
export * from "./TextWithFallbackDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__